import { booleanAttribute, ChangeDetectionStrategy, Component, input, model, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';
import { provideValueAccessor } from '../util';
import { ControlValidator } from '../util/control-validator';

/**
 * A round control that allows user to choose one option from a set.
 * This is the base element and if used directly you must wrap it with a label.
 * This will more often be used in the RadioOption or RadioGroup component.
 */
@Component({
  selector: 'bspk-radio',
  imports: [],
  templateUrl: './radio.component.html',
  styleUrl: './radio.component.scss',
  host: {
    'data-bspk': 'radio',
  },
  providers: [provideValueAccessor(BspkRadio)],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class BspkRadio<TValue = string> extends ControlValidator implements ControlValueAccessor {
  readonly ariaLabel = input.required<string>({ alias: 'aria-label' });
  readonly name = input.required<string>();
  readonly value = input.required<TValue>();
  readonly checked = model(false);
  readonly disabled = input(false, { transform: booleanAttribute });
  readonly invalid = input(false, { transform: booleanAttribute });
  readonly defaultChecked = input(false, { transform: booleanAttribute });

  private _onChange: (value: TValue) => void = () => {};
  private _onTouched: () => void = () => {};

  handleChange(event: Event): void {
    const { checked } = (event.target as HTMLInputElement);
    this.checked.set(checked);
    if (checked) {
      this._onChange(this.value());
    }
  }

  handleBlur() {
    this._onTouched();
  }

  registerOnChange(fn: any): void {
    this._onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this._onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
  }

  writeValue(obj: any): void {
    if (obj === this.value()) {
      this.checked.set(true);
    } else {
      this.checked.set(false);
    }
  }
}
